import { render, staticRenderFns } from "./MoleculeEditionAcademyUsersProfileAssets.vue?vue&type=template&id=7dad7d0e&"
import script from "./MoleculeEditionAcademyUsersProfileAssets.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyUsersProfileAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports